import PropTypes from 'prop-types';
import { Turnstile } from '@marsidev/react-turnstile';
import styles from './FormCaptchaField.module.scss';

const FormCaptchaField = ({ sitekey, setCaptchaToken, showErrorMessage = false, captchaRef = null }) => {
    return (
        <div className={styles['FormCaptchaField']}>
            <Turnstile
                siteKey={sitekey}
                onSuccess={setCaptchaToken}
                onErrorCapture={() => setCaptchaToken(null)}
                onExpire={() => setCaptchaToken(null)}
                ref={captchaRef}
                options={{
                    theme: 'light',
                }}
            />
            {showErrorMessage && (
                <span className={styles['FormCaptchaField__Error']}>
                    Please prove that you are not a robot
                </span>
            )}
        </div>
    );
};

FormCaptchaField.propTypes = {
    sitekey: PropTypes.string.isRequired,
    setCaptchaToken: PropTypes.func.isRequired,
};

export default FormCaptchaField;
